import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';
import { getDefaultHeight } from '../utils/get-default-height.js';

const BubblesGraphic = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 2600 99.6",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 99.6),
    ...svgProps,
    stroke: svgProps.stroke ?? "none",
    fill: color ?? svgProps.fill ?? "currentColor",
    children: /*#__PURE__*/jsx("path", {
      d: "M2600,37.2c-14.8,6.2-27.4,16.9-36.1,30.4c-8.7,4.6-16.9,9.8-24.5,15.7c-13.5-15.1-36.5-16.7-52-3.6 c-16.2-9.6-36-11.2-53.5-4.3c-20-23.2-54.1-27.7-79.5-10.7c-32.7-21.8-71.9-31.2-110.9-26.7c-10.2,1.1-20.3,3.2-30.2,6.1 c-8.9-2.6-18.1-4.1-27.4-4.4c-62.7-47.1-150.6-39.4-204.3,17.9c-18-6.8-37.7-7.7-56.3-2.7c-32.6-25.6-78.3-26.3-111.6-1.6 c-33.7-4.3-68,2.7-97.3,20c-27.8-40.9-83.3-51.3-124-23.5c-7,4.8-13.3,10.5-18.6,17.2c-30.6-3.6-61.6,3.1-88.1,18.9 c-23.8-13.4-52.1-16.1-78-7.7c-36.1-36.1-89.2-49-137.8-33.5c-19.9-12-42.5-18.7-65.7-19.5h-4.4c-32.4,0-62.2,11.4-85.6,30.5 c-29.8-9.2-61.3-11.3-92.1-6.3c-30.9-16.4-68.4-13.1-95.9,8.5l-2.1-0.1c-7.7,0-14.8,2.3-20.8,6.3c-15-11.4-34.5-15.3-52.7-10.2 C831.5,26,793.7,19,766,38.2c-5,3.5-9.5,7.6-13.2,12.4H752c-14.6,0-28.5,2.4-41.6,6.7c-31.7-16-68.4-18.9-102.3-8.2 c-19.9-12-42.5-18.7-65.7-19.5H538c-23.8,0-46.2,6.1-65.6,17c-8.6,3.1-16.9,7.1-24.6,12.1c-52.2-14.5-108-7.5-155.1,19.3 c-11.8-16.5-34.4-20.6-51.2-9.3c-15-11.4-34.5-15.3-52.7-10.2c-17.4-25.2-50.7-33.5-77.9-19.5C80.9,13.7,43-0.1,3.8,0H0v100h2600 V37.2z",
      style: {
        fillRule: "evenodd",
        clipRule: "evenodd"
      }
    })
  });
};

export { BubblesGraphic };
//# sourceMappingURL=bubbles.js.map
